import { obfuscationKey} from './utilfunctions.js';
const recaptchaVerification = (() => {
    let recaptchaDropZone, recaptchaDraggableShape, recaptchaShapeName, recaptchaModal, recaptchaModalContent, recaptchaErrorMessage, recaptchaRefreshButton, recaptchaCloseButton, recaptchaInstructions, recaptchaDropZoneContainer;
    let recaptchaStartTime, recaptchaIsVerified = false;
    let verificationEventName = "generateResumeVerificationSuccess";
    const MAX_ATTEMPTS = 3;
    const BLOCK_TIME_MINUTES = 1;
    let initialMultiple = 1;
    // const MAX_ATTEMPTS = 3;
    // const BLOCK_TIME_MINUTES = 5;
    // let initialMultiple = 3;
    let showCaptchaMultiple = initialMultiple;
    let email;
    let countdownInterval;

    let recaptchaShapes = [];

    const eventListeners = []; // Tracks all event listeners

    // Function to add listeners and track them
    const addToTheListener = (selector, event, handler, options = {}) => {
        if (selector instanceof Element || selector instanceof Document) {
            // Add event listener to an element or document
            selector.addEventListener(event, handler, options);
        } else {
            console.warn("Unsupported selector type:", selector);
            return;
        }

        // Track the event listener
        eventListeners.push({ selector, event, handler, options });
    };

    // Function to remove a specific listener and update tracking
    const removeListener = (selector, event, handler, options = {}) => {
        if (selector instanceof Element || selector instanceof Document) {
            selector.removeEventListener(event, handler, options);

            // Remove the listener from tracking
            const index = eventListeners.findIndex(
                (listener) =>
                    listener.selector === selector &&
                    listener.event === event &&
                    listener.handler === handler &&
                    JSON.stringify(listener.options) === JSON.stringify(options)
            );
            if (index !== -1) {
                eventListeners.splice(index, 1);
            }
        } else {
            console.warn("Unsupported selector type for removeListener:", selector);
        }
    };

    // Function to remove all tracked listeners
    const removeAllListeners = () => {
        eventListeners.forEach(({ selector, event, handler, options }) => {
            selector.removeEventListener(event, handler, options);
        });

        // Clear the eventListeners array
        eventListeners.length = 0;
    };


    function initializeRecaptchaShapes() {
        recaptchaShapes = [
            { name: getI18n('circle'), class: "recaptcha-circle" },
            { name: getI18n('triangle'), class: "recaptcha-triangle" },
            { name: getI18n('square'), class: "recaptcha-square" },
            { name: getI18n('pentagon'), class: "recaptcha-pentagon" },
            { name: getI18n('hexagon'), class: "recaptcha-hexagon" },
            { name: getI18n('rectangle'), class: "recaptcha-rectangle" },
            { name: getI18n('rhombus'), class: "recaptcha-rhombus" },
            { name: getI18n('parallelogram'), class: "recaptcha-parallelogram" },
            { name: getI18n('ellipse'), class: "recaptcha-ellipse" },
            { name: getI18n('heptagon'), class: "recaptcha-heptagon" },
            { name: getI18n('octagon'), class: "recaptcha-octagon" },
            { name: getI18n('nonagon'), class: "recaptcha-nonagon" },
            { name: getI18n('decagon'), class: "recaptcha-decagon" },
            { name: getI18n('trapezoid'), class: "recaptcha-trapezoid" },
            { name: getI18n('kite'), class: "recaptcha-kite" },
            { name: getI18n('star'), class: "recaptcha-star" }
        ];
    }

    function setInitialMultiple(initMultiple = 3) {
        console.log('Setting initial multiple for captcha to:', initMultiple);
        initialMultiple = initMultiple;
        showCaptchaMultiple = initialMultiple;
    }

    async function setRecaptchaData({ attemptCount = 0, captchaBlocked = null, failureCount = 0, captchaVisible = false } = {}) {
        const data = { attemptCount, captchaBlocked, failureCount, captchaVisible };
        //console.log("Attempting to set recaptcha data for email:", email);
        //console.log("Data being sent:", data);
        try {
            const response = await fetch(`${getApiUrl('data', 'loginapi/recaptcha')}?email=${encodeURIComponent(email)}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            });
            if (!response.ok) {
                throw new Error(`Error setting recaptcha data: ${response.statusText}`);
            }
            //console.log("Recaptcha data set successfully");
        } catch (error) {
            console.error("Failed to set recaptcha data:", error);
        }
    }

    async function getRecaptchaData() {
        try {
            const response = await fetch(`${getApiUrl('data', 'loginapi/recaptcha')}?email=${encodeURIComponent(email)}`);
            if (response.ok) {
                const data = await response.json();
                //console.log("Recaptcha data retrieved:", data);
                return data;
            } else {
                console.warn("No recaptcha data found, using default values");
                return { attemptCount: 0, captchaBlocked: null, failureCount: 0, captchaVisible: false };
            }
        } catch (error) {
            console.error("Failed to get recaptcha data:", error);
            return { attemptCount: 0, captchaBlocked: null, failureCount: 0, captchaVisible: false };
        }
    }

    async function deleteRecaptchaData() {
        try {
            const response = await fetch(`${getApiUrl('data', 'loginapi/recaptcha')}?email=${encodeURIComponent(email)}`, { method: 'DELETE' });
            if (!response.ok) {
                throw new Error(`Error deleting recaptcha data: ${response.statusText}`);
            }
            console.log("Recaptcha data deleted successfully");
        } catch (error) {
            console.error("Failed to delete recaptcha data:", error);
        }
    }

    async function recaptchaVerificationInit(eventName, userEmail, cancelCallBack) {
        verificationEventName = eventName || "generateResumeVerificationSuccess";

        const event = new CustomEvent(verificationEventName, {
            detail: { message: 'verificationCompleted' }
        });
        if (verifySecureFlag()) {
            window.dispatchEvent(event);
            return;
        }


        email = btoa(userEmail); //base64 encoded
        recaptchaDropZone = document.getElementById("recaptchaDropZone");
        recaptchaDraggableShape = document.getElementById("recaptchaDraggableShape");
        recaptchaShapeName = document.getElementById("recaptchaShapeName");
        recaptchaModal = document.getElementById("recaptchaVerificationModal");
        recaptchaModalContent = document.querySelector(".recaptcha-modal-content");
        recaptchaErrorMessage = document.getElementById("recaptchaMessage");
        recaptchaRefreshButton = document.querySelector(".recaptcha-refresh-btn");
        recaptchaCloseButton = document.querySelector(".recaptcha-close-btn");
        recaptchaInstructions = document.getElementById("recaptchaInstructions");
        recaptchaDropZoneContainer = document.querySelector(".recaptcha-drop-zone-container");

        recaptchaRefreshButton.style.display = "none";
        recaptchaDraggableShape.setAttribute("tabindex", "0");

        const data = await getRecaptchaData();

        const { attemptCount, captchaBlocked, failureCount, captchaVisible } =  data;

        if (captchaBlocked && Date.now() < captchaBlocked) {
            showBlockedMessage();
        } else if (captchaVisible || shouldShowCaptcha(attemptCount)) {
            openModal(data);
        } else {
            await bypassCaptcha(data);
        }

        addToTheListener(recaptchaDraggableShape, "mousedown", startDrag);
        addToTheListener(recaptchaDraggableShape, "touchstart", startDrag, { passive: true });
        addToTheListener(recaptchaDraggableShape, "keydown", moveShapeWithKeyboard);
        addToTheListener(recaptchaRefreshButton, "click", refreshVerification);

        // Define combined logic for close button
        const handleCloseClick = () => {
            if (cancelCallBack && typeof cancelCallBack === "function") {
                cancelCallBack(); // Invoke the cancel callback
            }
            closeModal(); // Close the modal
        };

        // Add close button listener with combined logic
        addToTheListener(recaptchaCloseButton, "click", handleCloseClick);
    }

    function shouldShowCaptcha(attemptCount) {
        if (attemptCount > 0 && attemptCount % showCaptchaMultiple === 0) {
            showCaptchaMultiple += 2;
            return true;
        }
        return false;
    }

    async function openModal(data) {
        const { captchaBlocked } = data;
        if (captchaBlocked && Date.now() < captchaBlocked) {
            showBlockedMessage();
            return;
        } else {
            await setRecaptchaData({ ...(data), captchaVisible: true });
            recaptchaModal.style.display = "flex";
            randomizeShape();
            recaptchaDraggableShape.focus();
        }
    }

    async function bypassCaptcha(data) {
        const event = new CustomEvent(verificationEventName, {
            detail: { message: 'verificationCompleted' }
        });
        const recaptchaData = data;
        const attemptCount = recaptchaData.attemptCount + 1;
        await setRecaptchaData({ ...recaptchaData, attemptCount });
        // console.log('Sending event:', verificationEventName);
        window.dispatchEvent(event);
    }

    function closeModal() {
        //console.log ('Closing recaptha modal');
        recaptchaModal.style.display = "none";
        resetVerification();
        removeAllListeners();

        if (typeof countdownInterval !== "undefined") {
            clearInterval(countdownInterval);
            countdownInterval = null; // Reset interval variable
        }

        recaptchaDropZone = null;
        recaptchaDraggableShape = null;
        recaptchaShapeName = null;
        recaptchaModal = null;
        recaptchaModalContent = null;
        recaptchaErrorMessage = null;
        recaptchaRefreshButton = null;
        recaptchaCloseButton = null;
        recaptchaInstructions = null;
        recaptchaDropZoneContainer = null;

        // Reset other variables
        recaptchaStartTime = null;
    }

    async function showBlockedMessage() {
        recaptchaModal.style.display = "flex";
        recaptchaErrorMessage.style.display = "block";
        recaptchaDropZone.style.display = "none";
        recaptchaDraggableShape.style.display = "none";
        recaptchaInstructions.style.display = "none";
        recaptchaDropZoneContainer.style.display = "none";
        recaptchaErrorMessage.style.height = "100%";

        showCaptchaMultiple = initialMultiple;

        const { captchaBlocked } = await getRecaptchaData();
        const blockedUntilTimestamp = captchaBlocked;

        if (blockedUntilTimestamp) {
            recaptchaErrorMessage.innerHTML = `
            <div class="blocked-message">
                <span class="too-many-text">${getI18n('toomanyrequestswait')}</span>
                <div class="countdown-container">
                    <div class="time-box">
                        <div class="flip-number minutes">00</div>
                        <div class="time-label">${getI18n('minutes')}</div>
                    </div>
                    <div class="separator">:</div>
                    <div class="time-box">
                        <div class="flip-number seconds">00</div>
                        <div class="time-label">${getI18n('seconds')}</div>
                    </div>
                </div>
            </div>`;

            const minutesElement = recaptchaErrorMessage.querySelector(".flip-number.minutes");
            const secondsElement = recaptchaErrorMessage.querySelector(".flip-number.seconds");

            function updateCountdown() {
                const now = Date.now();
                const timeRemaining = blockedUntilTimestamp - now;

                if (timeRemaining > 0) {
                    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
                    minutesElement.textContent = String(minutes).padStart(2, '0');
                    secondsElement.textContent = String(seconds).padStart(2, '0');
                } else {
                    clearInterval(countdownInterval);
                    setRecaptchaData({ attemptCount: 0, captchaBlocked: null, failureCount: 0, captchaVisible: false });
                    recaptchaErrorMessage.style.display = "";
                    recaptchaDropZone.style.display = "";
                    recaptchaInstructions.style.display = "";
                    recaptchaDropZoneContainer.style.display = "";
                    resetVerification();
                    closeModal();
                }
            }

            updateCountdown();
            countdownInterval = setInterval(updateCountdown, 1000);
        } else {
            recaptchaErrorMessage.textContent = getI18n('errorRetrievingCountdown');
        }
    }

    function randomizeShape(retries = 3) {
        initializeRecaptchaShapes();
        const randomShape = recaptchaShapes[Math.floor(Math.random() * recaptchaShapes.length)];
        recaptchaShapeName.textContent = randomShape.name;
        recaptchaDraggableShape.className = `recaptcha-shape ${randomShape.class}`;

        const modalRect = recaptchaModalContent.getBoundingClientRect();
        const dropZoneRect = recaptchaDropZone.getBoundingClientRect();

        let shapeX, shapeY;
        const positionOptions = ["left", "right", "bottom"];
        const position = positionOptions[Math.floor(Math.random() * positionOptions.length)];

        if (position === "left") {
            shapeX = dropZoneRect.left - modalRect.left - 60;
            shapeY = dropZoneRect.top - modalRect.top;
        } else if (position === "right") {
            shapeX = dropZoneRect.right - modalRect.left + 10;
            shapeY = dropZoneRect.top - modalRect.top;
        } else {
            shapeX = dropZoneRect.left - modalRect.left;
            shapeY = dropZoneRect.bottom - modalRect.top + 10;
        }

        recaptchaDraggableShape.style.left = `${shapeX}px`;
        recaptchaDraggableShape.style.top = `${shapeY}px`;

        setCustomTimeout(() => {
            const shapeRect = recaptchaDraggableShape.getBoundingClientRect();
            if ((shapeRect.width === 0 || shapeRect.height === 0) && retries > 0) {
                randomizeShape(retries - 1);
            }
        }, 100);
    }

    function resetVerification() {
        recaptchaIsVerified = false;
        recaptchaErrorMessage.textContent = "";
        recaptchaErrorMessage.style.display = "none";
        recaptchaRefreshButton.style.display = "none";
        recaptchaDropZone.textContent = getI18n('drop_here');
        recaptchaDropZone.classList.remove("active", "error");
        recaptchaDraggableShape.style.display = "block";
        recaptchaDraggableShape.style.transform = "translate(0, 0)";
    }

    async function refreshVerification() {
        resetVerification();
        randomizeShape();
    }

    let recaptchaOffsetX, recaptchaOffsetY;

    function startDrag(event) {
        recaptchaOffsetX = event.clientX || event.touches[0].clientX;
        recaptchaOffsetY = event.clientY || event.touches[0].clientY;
        recaptchaStartTime = new Date().getTime();

        addToTheListener(document, "mousemove", dragging);
        addToTheListener(document, "touchmove", dragging, { passive: true });
        addToTheListener(document, "mouseup", endDrag);
        addToTheListener(document, "touchend", endDrag);
    }

    function dragging(event) {
        const moveX = (event.clientX || event.touches[0].clientX) - recaptchaOffsetX;
        const moveY = (event.clientY || event.touches[0].clientY) - recaptchaOffsetY;
        recaptchaDraggableShape.style.transform = `translate(${moveX}px, ${moveY}px)`;
    }

    function endDrag(event) {
        const dropZoneRect = recaptchaDropZone.getBoundingClientRect();
        const shapeRect = recaptchaDraggableShape.getBoundingClientRect();

        if (
            shapeRect.left >= dropZoneRect.left &&
            shapeRect.top >= dropZoneRect.top &&
            shapeRect.right <= dropZoneRect.right &&
            shapeRect.bottom <= dropZoneRect.bottom
        ) {
            recaptchaIsVerified = true;
            recaptchaDropZone.textContent = "Verified!";
            recaptchaDropZone.classList.add("active");
            recaptchaDraggableShape.style.display = "none";
            verifyAndClose();
        } else {
            recaptchaDraggableShape.style.transform = "translate(0, 0)";
        }

        removeListener(document, "mousemove", dragging);
        removeListener(document, "touchmove", dragging, { passive: true });
        removeListener(document, "mouseup", endDrag);
        removeListener(document, "touchend", endDrag);
    }

    function moveShapeWithKeyboard(event) {
        const step = 5;
        const shapeRect = recaptchaDraggableShape.getBoundingClientRect();
        const modalRect = recaptchaModalContent.getBoundingClientRect();

        switch (event.key) {
            case "ArrowUp":
                recaptchaDraggableShape.style.top = `${shapeRect.top - step - modalRect.top}px`;
                break;
            case "ArrowDown":
                recaptchaDraggableShape.style.top = `${shapeRect.top + step - modalRect.top}px`;
                break;
            case "ArrowLeft":
                recaptchaDraggableShape.style.left = `${shapeRect.left - step - modalRect.left}px`;
                break;
            case "ArrowRight":
                recaptchaDraggableShape.style.left = `${shapeRect.left + step - modalRect.left}px`;
                break;
            case "Enter":
            case " ":
                const dropZoneRect = recaptchaDropZone.getBoundingClientRect();
                if (
                    shapeRect.left >= dropZoneRect.left &&
                    shapeRect.top >= dropZoneRect.top &&
                    shapeRect.right <= dropZoneRect.right &&
                    shapeRect.bottom <= dropZoneRect.bottom
                ) {
                    verifyAndClose();
                }
                break;
        }
    }

    async function setCookieAndDispatch(event) {
        window.dispatchEvent(event);
        storeSecureFlag();
    }



    async function verifyAndClose() {
        const timeTaken = new Date().getTime() - recaptchaStartTime;
        const recaptchaData = await getRecaptchaData();
        let { attemptCount, failureCount } = recaptchaData;

        if (timeTaken < 500) {
            failureCount += 1;
            const remainingAttempts = MAX_ATTEMPTS - failureCount;
            recaptchaErrorMessage.textContent = `${getI18n('tooQuick')}, ${remainingAttempts} ${getI18n('attemptsLeft')}`;
            recaptchaErrorMessage.style.display = "block";
            recaptchaDropZone.textContent = getI18n('failed');
            recaptchaDropZone.classList.add("error");
            recaptchaRefreshButton.style.display = remainingAttempts > 0 ? "inline-block" : "none";

            if (failureCount >= MAX_ATTEMPTS) {
                await setRecaptchaData({
                    attemptCount,
                    captchaBlocked: Date.now() + BLOCK_TIME_MINUTES * 60 * 1000,
                    failureCount,
                    captchaVisible: false
                });
                showBlockedMessage();
            } else {
                await setRecaptchaData({ attemptCount, failureCount, captchaVisible: true });
            }
            return;
        } else {
            recaptchaErrorMessage.textContent = getI18n('verificationSuccessful');
            recaptchaErrorMessage.style.color = "green";
            recaptchaErrorMessage.style.display = "block";
            recaptchaDropZone.classList.remove("error");
            recaptchaDropZone.classList.add("active");
            recaptchaDropZone.textContent = getI18n('verified');
            recaptchaDraggableShape.style.display = "none";
            await deleteRecaptchaData();
           // console.log('Sending event:', verificationEventName);

            const event = new CustomEvent(verificationEventName, {
                detail: { message: 'verificationCompleted' }
            });
            setCookieAndDispatch(event);

            setCustomTimeout(closeModal, 500);
        }
    }


    function generateContextHash() {
        return [
            navigator.userAgent,
            screen.width,
            screen.height,
            screen.colorDepth,
            new Date().getTimezoneOffset()
        ].join('|');
    }

    function storeSecureFlag() {
        const fingerprint = generateContextHash();
        const payload = JSON.stringify({ v: 1, f: fingerprint }); // 'v' for verified, 'f' for fingerprint
        const obfuscated = secureTransform(payload, obfuscationKey);
        setLocalStorageItem('xflag', obfuscated);
    }


    function verifySecureFlag() {
        const value = getLocalStorageItem('xflag');
        if (!value) return false;

        const decoded = reverseTransform(value, obfuscationKey);
        if (!decoded) return false;

        try {
            const parsed = JSON.parse(decoded);
            return parsed.v === 1 && parsed.f === generateContextHash();
        } catch {
            return false;
        }
    }


    function secureTransform(input, key) {
        const full = key + input;
        const bytes = new TextEncoder().encode(full);
        const binary = Array.from(bytes).map(b => String.fromCharCode(b)).join('');
        return btoa(binary);
    }

    function reverseTransform(encoded, key) {
        try {
            const binary = atob(encoded);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            const decoded = new TextDecoder().decode(bytes);
            return decoded.startsWith(key) ? decoded.slice(key.length) : null;
        } catch {
            return null;
        }
    }



    return {
        recaptchaVerificationInit,
        openModal,
        closeModal,
        setInitialMultiple
    };
})();

export { recaptchaVerification };
